enum WidgetFieldType {
  Text = 1,
  TextArea = 2,
  Number = 3,
  Select = 4,
  Boolean = 5,
  Color = 6,
  Image = 7,
  Date = 8,
  Font = 9,
  Video = 10,
}

export {WidgetFieldType};
